<div class="flex flex-col">
  <form (keydown.enter)="$event.preventDefault()" [formGroup]="manageStageAreaForm">
    <mat-form-field *ngIf="stageAreas" appearance="outline" class="w-p-100">
      <mat-label>Data Type</mat-label>
      <mat-select (selectionChange)="onSourceChange($event)" formControlName="sourceType">
        <mat-option *ngFor="let stageArea of stageAreas" [value]="stageArea.id">
          {{stageArea.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-p-100">
      <mat-label>Reference Type</mat-label>
      <div class="flex flex-row justify-start items-center">
        <input type="text"
               placeholder="Pick one"
               aria-label="Number"
               matInput
               formControlName="referenceType"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let referenceType of filteredOptions"
                      [value]="referenceType">{{referenceType}}</mat-option>
        </mat-autocomplete>
        <button [disabled]="disableAddReference" mat-button class="action-button add-to-fil-btn"
                *ngIf="possibleNewReference" (click)="onAddReferenceType()">Add To Reference Type
        </button>
      </div>
      <!-- <mat-error *ngIf="filingForm.get('filingType').hasError('required') && filingForm.get('filingType').touched">This is a required field</mat-error> -->
    </mat-form-field>
  </form>

  <div style="max-height: 300px;" class="simple-scroll">
    <ng-container *ngIf="sourceTypeGroup">
      <div class="mat-panel-container">
        <mat-accordion
          [ngClass]="{checked: sourceType.isSelected}"
          class="flex flex-col"
          *ngFor="let sourceType of sourceTypeGroup.sourceTypes">
          <mat-expansion-panel
            [expanded]="true"
            (click)="$event.stopPropagation();"
            hideToggle="true"
          >
            <mat-expansion-panel-header
              [collapsedHeight]="'auto'"
              [expandedHeight]="'auto'"
            >
              <mat-panel-title
                *ngIf="sourceType && sourceType.fieldDefinitions && sourceType.fieldDefinitions.length > 0">
                <div  class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis ">
                  <mat-icon class="mat-icon-rtl-mirror" (click)="sourceType.isExpanded = !sourceType.isExpanded">
                    {{sourceType.isExpanded ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                  <mat-checkbox
                    (click)="$event.stopPropagation();"
                    (change)="onSourceCheckBoxClicked($event, sourceType)"
                    [checked]="isAllSourceFieldSelected(sourceType)"
                    [indeterminate]="hasSourceFieldsIndeterminateState(sourceType)"
                  >           {{sourceType.name}}
                  </mat-checkbox>
                  <div class="links flex flex-row justify-end items-center"></div>

                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul *ngIf="sourceType.fieldDefinitions">
              <li
                *ngFor="let field of sourceType.fieldDefinitions"
                [ngClass]="{checked: field.frozen}"
                class="flex flex-row"
              >
                <mat-checkbox [checked]="field.isSelected" [disabled]="field.frozen"
                              (change)="onFieldChange($event, field, sourceType)"
                >
                  {{field.header}}
                </mat-checkbox>
                <div class="link flex flex-row justify-end items-centers"></div>
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </ng-container>
  </div>

</div>
